export default __webpack_public_path__ + "media/images/front/snsBnr/pc_sns_insta-1799b62b6c895077a5751e0b028014a8.png";